// =============================================================================
// FILE:
// frontend/src/pms/task_execution/tabs/RequestsTab.js
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  Eye
} from "lucide-react";

import RequestDetailDrawer
from "../drawers/RequestDetailDrawer";

import {
  getTaskMaterialRequests,
  submitMaterialRequest
} from "../services/taskMaterialRequestService";


// =============================================================================
// COMPONENT
// =============================================================================

export default function RequestsTab({

  task

}) {


  // ===========================================================================
  // STATE
  // ===========================================================================
  const [rows, setRows] =
    useState([]);


  const [loading, setLoading] =
    useState(false);

  const [detailDrawerOpen, setDetailDrawerOpen] =
    useState(false);


const [selectedRequestId, setSelectedRequestId] =
  useState(null);


  // ===========================================================================
  // LOAD
  // ===========================================================================
  useEffect(() => {

    loadRequests();

  }, [task]);


  // ===========================================================================
  // LOAD REQUESTS
  // ===========================================================================
    // ===========================================================================
  // LOAD REQUESTS
  // ===========================================================================
  const loadRequests =
    async () => {

      try {

        setLoading(true);


        // ---------------------------------------------------------------
        // LIVE API
        // ---------------------------------------------------------------
        const response =
          await getTaskMaterialRequests(
            task?.id
          );
        // ---------------------------------------------------------------
        // SET ROWS
        // ---------------------------------------------------------------
        setRows(
          response?.data || []
        );


        // ---------------------------------------------------------------
        // RESPONSE
        // ---------------------------------------------------------------
        

      } catch (err) {

        console.error(
          "Failed to load requests",
          err
        );

      } finally {

        setLoading(false);
      }
    };
  


    // ===========================================================================
  // SUBMIT REQUEST
  // ===========================================================================
  const handleSubmitRequest =
    async (requestId) => {

      try {

        await submitMaterialRequest(
          requestId
        );


        // -------------------------------------------------------------
        // RELOAD GRID
        // -------------------------------------------------------------
        loadRequests();

      } catch (err) {

        console.error(
          "Failed to submit request",
          err
        );
      }
    };
  
    // ===========================================================================
  // VIEW DETAILS
  // ===========================================================================
  const handleViewRequest =
  (row) => {

    setSelectedRequestId(
      row.id
    );

    setDetailDrawerOpen(true);
  };

    
  // ===========================================================================
  // LOADING
  // ===========================================================================
  if (loading) {

    return (

      <div style={styles.loader}>

        Loading requests...

      </div>
    );
  }


  // ===========================================================================
  // EMPTY
  // ===========================================================================
  if (!rows || rows.length === 0) {

    return (

      <div style={styles.emptyState}>

        No requests found

      </div>
    );
  }


  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <div style={styles.container}>


      {/* ================================================================ */}
      {/* HEADER */}
      {/* ================================================================ */}
      <div style={styles.sectionHeader}>


        <div>

          <div style={styles.title}>

            Material Requests

          </div>


          <div style={styles.subtitle}>


            Request workflow,
            approval tracking,
            issue lifecycle,
            and execution readiness

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* GRID */}
      {/* ================================================================ */}
      <div style={styles.gridContainer}>


        {/* ============================================================ */}
        {/* HEADER */}
        {/* ============================================================ */}
        <div style={styles.headerRow}>


          <div style={styles.colRequest}>
            Request
          </div>


          <div style={styles.colDate}>
            Date
          </div>


          <div style={styles.colStatus}>
            Status
          </div>


          <div style={styles.colQty}>
            Total Lines
          </div>


          <div style={styles.colQty}>
            Approved
          </div>


          <div style={styles.colQty}>
            Issued
          </div>


          <div style={styles.colUser}>
            Requested By
          </div>


          <div style={styles.colRemarks}>
            Remarks
          </div>


          <div style={styles.colAction}>
            Action
          </div>

        </div>


        {/* ============================================================ */}
        {/* BODY */}
        {/* ============================================================ */}
        {

          rows.map((row) => (

            <div
              key={row.id}
              style={styles.dataRow}
            >


              {/* ------------------------------------------------------ */}
              {/* REQUEST */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colRequest}>


                <div style={styles.requestNo}>


                  {row.request_no}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* DATE */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colDate}>


                <div style={styles.cellText}>


                  {row.request_date}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* STATUS */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colStatus}>


                <span style={
                  getStatusStyle(
                    row.request_status
                  )
                }>

                  {
                    formatStatus(
                      row.request_status
                    )
                  }

                </span>

              </div>


              {/* ------------------------------------------------------ */}
              {/* TOTAL */}
              {/* ------------------------------------------------------ */}
              <QtyCell
                value={row.total_lines}
              />


              {/* ------------------------------------------------------ */}
              {/* APPROVED */}
              {/* ------------------------------------------------------ */}
              <QtyCell
                value={row.approved_lines}
              />


              {/* ------------------------------------------------------ */}
              {/* ISSUED */}
              {/* ------------------------------------------------------ */}
              <QtyCell
                value={row.issued_lines}
              />


              {/* ------------------------------------------------------ */}
              {/* USER */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colUser}>


                <div style={styles.cellText}>


                  {row.requested_by}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* REMARKS */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colRemarks}>


                <div style={styles.remarksText}>


                  {row.remarks || "-"}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* ACTION */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colAction}>


              {/* ---------------------------------------------------------- */}
              {/* VIEW */}
              {/* ---------------------------------------------------------- */}
              <button
                style={styles.viewBtn}
                onClick={() =>
                  handleViewRequest(row)
                }
              >

                <Eye size={14} />

                View

              </button>


              {/* ---------------------------------------------------------- */}
              {/* SUBMIT */}
              {/* ---------------------------------------------------------- */}
              {

                row.request_status === "DRAFT"

                && (

                  <button

                    style={styles.submitBtn}

                    onClick={() =>
                      handleSubmitRequest(
                        row.id
                      )
                    }
                  >

                    Submit

                  </button>
                )
              }

            </div>

            </div>
          ))
        }

      </div>
            {/* ================================================================ */}
            {/* REQUEST DETAIL DRAWER */}
            {/* ================================================================ */}
            <RequestDetailDrawer

              open={detailDrawerOpen}

              requestId={selectedRequestId}

              onClose={() => {

                setDetailDrawerOpen(false);

                setSelectedRequestId(null);
              }}
            />

    </div>
  );
}


// =============================================================================
// QTY CELL
// =============================================================================

function QtyCell({

  value

}) {

  return (

    <div style={styles.colQty}>


      <div style={styles.qtyValue}>


        {value || 0}

      </div>

    </div>
  );
}


// =============================================================================
// HELPERS
// =============================================================================

function formatStatus(status) {

  if (!status) {
    return "-";
  }

  return status
    .replaceAll("_", " ");
}


function getStatusStyle(status) {

  switch (status) {

    case "APPROVED":

      return styles.statusGreen;

    case "PARTIALLY_APPROVED":

      return styles.statusOrange;

    case "SUBMITTED":

      return styles.statusBlue;

    case "REJECTED":

      return styles.statusRed;

    case "ISSUED":

      return styles.statusPurple;

    default:

      return styles.statusGray;
  }
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  container: {

    display: "flex",

    flexDirection: "column"
  },

  sectionHeader: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 18,

    marginBottom: 18,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  title: {

    fontSize: 18,

    fontWeight: 700,

    color: "#111827"
  },

  subtitle: {

    marginTop: 6,

    fontSize: 13,

    color: "#6b7280"
  },

  gridContainer: {

    background: "#ffffff",

    borderRadius: 14,

    overflow: "hidden",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  headerRow: {

    display: "flex",

    background: "#f3f4f6",

    borderBottom:
      "1px solid #e5e7eb",

    padding: "14px 16px",

    fontSize: 13,

    fontWeight: 700,

    color: "#374151"
  },

  dataRow: {

    display: "flex",

    alignItems: "center",

    padding: "16px",

    borderBottom:
      "1px solid #f3f4f6"
  },

  colRequest: {

    width: 180
  },

  requestNo: {

    fontSize: 13,

    fontWeight: 700,

    color: "#2563eb"
  },

  colDate: {

    width: 140
  },

  cellText: {

    fontSize: 13,

    color: "#111827"
  },

  colStatus: {

    width: 180,

    display: "flex",

    justifyContent: "center"
  },

  colQty: {

    width: 110,

    display: "flex",

    justifyContent: "center"
  },

  qtyValue: {

    fontSize: 14,

    fontWeight: 700,

    color: "#111827"
  },

  colUser: {

    width: 180
  },

  colRemarks: {

    flex: 1,

    paddingRight: 20
  },

  remarksText: {

    fontSize: 13,

    color: "#374151"
  },

  colAction: {

  width: 220,

  display: "flex",

  alignItems: "center",

  justifyContent: "center"
},

  viewBtn: {

    height: 34,

    border: "none",

    background: "#2563eb",

    color: "#ffffff",

    borderRadius: 8,

    padding: "0 12px",

    display: "flex",

    alignItems: "center",

    gap: 6,

    cursor: "pointer",

    fontWeight: 600
  },

    submitBtn: {

    height: 34,

    border: "none",

    background: "#16a34a",

    color: "#ffffff",

    borderRadius: 8,

    padding: "0 12px",

    cursor: "pointer",

    fontWeight: 600,

    marginLeft: 8
  },

  statusGreen: {

    background: "#dcfce7",

    color: "#166534",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  statusOrange: {

    background: "#ffedd5",

    color: "#c2410c",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  statusBlue: {

    background: "#dbeafe",

    color: "#1d4ed8",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  statusRed: {

    background: "#fee2e2",

    color: "#991b1b",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  statusPurple: {

    background: "#ede9fe",

    color: "#6d28d9",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  statusGray: {

    background: "#e5e7eb",

    color: "#374151",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  loader: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 40,

    textAlign: "center"
  },

  emptyState: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 40,

    textAlign: "center",

    color: "#6b7280"
  }
};